/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maintain_Clock_Times_HelpInputs */



/**
* | output |
* | --- |
* | "The timing will remain the same, but will be represented by different SMPTE timecode values" |
*
* @param {Maintain_Clock_Times_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const maintain_clock_times_help = /** @type {((inputs?: Maintain_Clock_Times_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maintain_Clock_Times_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Le minutage restera identique, mais sera représenté par des valeurs de timecode SMPTE différentes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Zeitmessung bleibt gleich, wird aber durch unterschiedliche SMPTE-Timecode-Werte dargestellt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("La temporizzazione rimarrà la stessa, ma sarà rappresentata da diversi valori di timecode SMPTE")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Время останется прежним, но будет отображаться другими значениями временного кода SMPTE.")
	if (locale === "es") return /** @type {LocalizedString} */ ("El tiempo seguirá siendo el mismo, pero estará representado por diferentes valores de código de tiempo SMPTE.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("时间轴保持不变，但会用不同的 SMPTE 时间码值表示。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("タイミングは同じままですが、異なるSMPTEタイムコード値で表されます。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समय वही रहेगा, लेकिन इसे अलग-अलग SMPTE टाइमकोड मानों द्वारा दर्शाया जाएगा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("A sincronização permanecerá a mesma, mas será representada por diferentes valores de código de tempo SMPTE.")
	return /** @type {LocalizedString} */ ("The timing will remain the same, but will be represented by different SMPTE timecode values")
});